module.exports = __webpack_public_path__ + "static/media/trikse.05fcf513.m4a";